import { EMPTY_STRING } from "src/components/constant/constant";

export const graphqlSearchActivityFields = {
  total_pages: true,
  total_size: true,
  activity_listing: {
    data: true,
    activity_id: true,
    link_id: true,
    activity_name: true,
    activity_purpose: true,
    activity_status: true,
    process_status: true,
    end_timestamp: true,
    start_timestamp: true,
    created_at: true,
    owner_id: true,
    receipt_available: true,
    approval_number: true,
    attributes: {
      verified: true,
      tagged_users: true,
      expense_id: true,
      accounting_id: true,
      accounting_status: true,
      settled_amount: true,
      settlement_delta: true,
      settled_at: true
    },
    xero_details: {
      // xero_account_id: true,
      // xero_tracking_category_mapping: true,
      xero_bank_transaction_id: true
    }
  }
};

export const graphqlSearchUserFields = {
  total_pages: true,
  total_size: true,
  user_listing: {
    attributes: {
      address: {
        city: true,
        country: true,
        post_code: true,
        line_1: true,
        line_2: true,
        state: true
      },
      first_name: true,
      last_name: true
    },
    current_organisation_role: true,
    created_at: true,
    display_id: true,
    email: true,
    is_active: true,
    phone: true,
    user_id: true,
    username: true,
    roles: {
      value: true,
      organisation_id: true
    }
  }
};

export function buildGraphqlFieldsFromMap(fieldsObj: Record<string, any>): string {
  return Object.entries(fieldsObj)
    .filter(([, value]) => value)
    .map(([key, value]) => {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const nested = buildGraphqlFieldsFromMap(value);

        return `${key} { ${nested} }`;
      }
      if (value === true) {
        return key;
      }
      return EMPTY_STRING;
    })
    .filter(Boolean)
    .join(" ");
}
